import { HardwareSupplierFilterKeyType, SUPPLIER_INTEGRATION_TYPES } from 'opensolar-common'
import { useGetSupplierConfig } from './useGetSupplierConfig'

/**
 * Determines whether the supplier uses a price-on-application model.
 *
 * @param supplierFilterKey - The supplier filter key of the selected distributor.
 * @returns true if the supplier has an integration type of 'price_on_application'.
 */
const useIsPriceOnApplication = (supplierFilterKey: HardwareSupplierFilterKeyType | undefined): boolean => {
  const { getSupplierConfig } = useGetSupplierConfig()

  if (!supplierFilterKey || supplierFilterKey === 'component') return false
  const integrationType = getSupplierConfig(supplierFilterKey)?.integrationType
  return integrationType === SUPPLIER_INTEGRATION_TYPES.PRICE_ON_APPLICATION
}

export default useIsPriceOnApplication
